"use client"
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";

import BgImage from '@/public/pcps_bg.jpeg'

export default function Hero() {

    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, [])

    const pcpsTitleRef = useRef<HTMLParagraphElement>(null);

    useEffect(() => {
        const scrollListener = () => {
            if (pcpsTitleRef.current) {
                pcpsTitleRef.current.style.transform = `translate3d(0px, -${window.scrollY * 0.175}px, 0px)`;
            }
        };
        window.addEventListener("scroll", scrollListener);
        return () => {
            window.removeEventListener("scroll", scrollListener);
        };
    }, []);

    if (!mounted) {
        return (
            <header className={cn(
                `h-[93vh] mt-0 xl:mb-[5rem] xl:pt-[6.25rem]`,
                // `md:mb-[3.75rem] md:pt-[4.375rem]`,
                `md:mb-[3.75rem] mb-[2.75rem] md:pt-[4.375rem]`,
                `float-left w-full clear-both overflow-hidden relative pt-[3.75rem]
             pb-[2rem] min-h-[26.375rem] max-h-[60rem] `,
            )}>
                <div
                    className={cn(
                        // `md:mt-[-1.0625rem] `,
                        `md:mt-[2.0625rem] `,
                        `pt-0 pb-0 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 `,
                        `z-[2] w-[87.5%] max-w-[90rem] flex m-auto p-[3.125rem_0_1.875rem]`
                    )}
                >
                    <div className={cn(
                        `md:flex`,
                        `basis-[calc(100%-1.6875rem)]`
                    )}>
                        <div className={cn(
                            `md:basis-auto  md:mr-[1.125rem]`,
                            `xl:max-w-[60rem] `
                        )}>
                            {/* <span
                            className={
                                cn(
                                    `xl:text-shadow-[0_0_2.25rem_#111111] xl:text-[.75rem] xl:leading-[.75rem] 
                                    xl:tracking-[0.0625rem]`,
                                    `md:text-shadow-[0_0_2rem_#111111] md:text-[0.6875rem] md:leading-[0.75rem] md:tracking-[0.09375rem] md:mt-[-0.125rem]`,
                                    `text-shadow-[0_0_1.5rem_#111111]`,
                                    `float-left clear-both text-white text-[0.625rem] leading-[1.125rem] tracking-[0.08125rem] uppercase m-[-0.3125rem_auto_0.625rem] futura-heavy`
                                )
                            }
                        >
                            Ideas Made To Matter
                        </span> */}
                            <div
                                // href={"#"}
                                className={cn(
                                    `float-left w-full clear-both block hover:decoration-white [text-decoration:none]`
                                )}
                            >
                                <h1
                                    className={cn(
                                        `xl:text-[3.75rem] xl:text-shadow-[0_0_2.25rem_#111111]`,
                                        `md:text-[2.75rem] md:text-shadow-[0_0_2rem_#111111]`,
                                        `mb-0 text-[1.5rem] text-shadow-[0_0_1.5rem_#111111]`,
                                        `leading-[1.25] text-white mb-[0.8125rem] clear-both wrap-break-word 
                                    font-black [text-decoration:none]`
                                    )}
                                >
                                    The Most Career Focused UK Degree in Nepal.
                                </h1>

                                <div className="flex md:flex-row flex-col justify-start gap-6 md:gap-12 my-4">
                                    <Link
                                        href={"https://apply.patancollege.edu.np/"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`w-fit text-xs font-bold leading-[1.125rem] tracking-[0.0625rem] text-white
                                             [text-decoration:none] uppercase
                    border border-white border-2  p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
                    after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                    after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:border-secondary-red hover:transition-[all_0.15s_ease]
                    after:hover:text-primary-red after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                      hover:after:transition-[all_0.15s_ease]
                            hover:after:transform hover:after:translate-x-[0.625rem]
                            
                  `}
                                    >
                                        Enroll now
                                    </Link>
                                    <Link
                                        href={"#courses"}
                                        // target="_blank"
                                        /*  className={`futura-medium text-[0.6875rem] leading-[1.125rem] tracking-[0.0625rem] text-white
                                             [text-decoration:none] uppercase
                    border border-white p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
                    after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                    after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:text-[#A31F34] hover:border-[#A31F34] hover:transition-[all_0.15s_ease]
                    after:hover:text-[#A31F34] after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                      hover:after:text-[#A31F34] hover:after:transition-[all_0.15s_ease]
                            hover:after:transform hover:after:translate-x-[0.625rem]
                            
                  `} */
                                        className={`w-fit text-xs font-bold leading-[1.125rem] tracking-[0.0625rem] text-white
                                             [text-decoration:none] uppercase
                    border border-white border-2  p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
                    after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                    after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:border-secondary-red hover:transition-[all_0.15s_ease]
                    after:hover:text-primary-red after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                      hover:after:transition-[all_0.15s_ease]
                            hover:after:transform hover:after:translate-x-[0.625rem]
                            
                  `}
                                    >
                                        Explore Our Courses
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="header-gradient bg-transparent" />
                {/*  <figure
                className="absolute top-0 left-0 m-0 z-0 h-full w-full"
                style={{
                    backgroundImage: `url('/pcps_bg.jpeg')`,
                    // backgroundImage: `url('/pcpsbg.jpg')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    // backgroundColor: "rgba(0, 0, 0, 0.3)",
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                    backgroundBlendMode: "multiply",
                    margin: 0,
                    zIndex: 0,
                }}
            /> */}
                <div className="absolute top-0 left-0 m-0 z-0 h-full w-full pointer-events-none">
                    <Image
                        src={BgImage}
                        alt="Pcps"
                        fill
                        className="h-full w-full object-cover object-center"
                        style={{ zIndex: 0 }}
                        priority
                    />
                    <div className="absolute inset-0 bg-[rgba(0,0,0,0.2)] mix-blend-multiply pointer-events-none" />
                </div>

                {/*  <p
                className="text-white text-[18rem] font-black absolute uppercase right-0 pointer-events-none z-[1] select-none"
                ref={pcpsTitleRef}
                style={{
                    transform: `translate3d(0px, -${window.scrollY * 0.175}px, 0px)`,
                    // width: "53.625rem",
                    // height: "22.25rem",
                    bottom: "-12.5rem",
                    // bottom: "0",
                }}
            >
                PCPS
            </p> */}
                <p
                    className="
                    text-white font-black tracking-tight absolute uppercase right-0 pointer-events-none z-[1] select-none
                    text-[7rem] sm:text-[10rem] md:text-[14rem] lg:text-[18rem] xl:bottom-[-12.5rem] md:bottom-[-8rem] bottom-[-4rem]
                "
                // ref={pcpsTitleRef}
                /*  style={{
                     transform: `translate3d(0px, -${window.scrollY * 0.175}px, 0px)`,
                     bottom: window.innerWidth >= 1024
                         ? "-12.5rem"
                         : window.innerWidth >= 768
                             ? "-8rem"
                             : window.innerWidth >= 640
                                 ? "-4rem"
                                 : "-2rem"
                 }} */
                >
                    PCPS
                </p>
            </header>
        )
    } else {
        return <header className={cn(
            `h-[93vh] mt-0 xl:mb-[5rem] xl:pt-[6.25rem]`,
            `md:mb-[3.75rem] md:pt-[4.375rem]`,
            `float-left w-full clear-both overflow-hidden relative pt-[3.75rem]
             pb-[2rem] min-h-[26.375rem] max-h-[60rem] `,
        )}>
            <div
                className={cn(
                    // `md:mt-[-1.0625rem] `,
                    `md:mt-[2.0625rem] `,
                    `pt-0 pb-0 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 `,
                    `z-[2] w-[87.5%] max-w-[90rem] flex m-auto p-[3.125rem_0_1.875rem]`
                )}
            >
                <div className={cn(
                    `md:flex`,
                    `basis-[calc(100%-1.6875rem)]`
                )}>
                    <div className={cn(
                        `md:basis-auto  md:mr-[1.125rem]`,
                        `xl:max-w-[60rem] `
                    )}>
                        {/* <span
                            className={
                                cn(
                                    `xl:text-shadow-[0_0_2.25rem_#111111] xl:text-[.75rem] xl:leading-[.75rem] 
                                    xl:tracking-[0.0625rem]`,
                                    `md:text-shadow-[0_0_2rem_#111111] md:text-[0.6875rem] md:leading-[0.75rem] md:tracking-[0.09375rem] md:mt-[-0.125rem]`,
                                    `text-shadow-[0_0_1.5rem_#111111]`,
                                    `float-left clear-both text-white text-[0.625rem] leading-[1.125rem] tracking-[0.08125rem] uppercase m-[-0.3125rem_auto_0.625rem] futura-heavy`
                                )
                            }
                        >
                            Ideas Made To Matter
                        </span> */}
                        <div
                            // href={"#"}
                            className={cn(
                                `float-left w-full clear-both block hover:decoration-white [text-decoration:none]`
                            )}
                        >
                            <h1
                                className={cn(
                                    `xl:text-[3.75rem] xl:text-shadow-[0_0_2.25rem_#111111]`,
                                    `md:text-[3.15rem] md:text-shadow-[0_0_2rem_#111111]`,
                                    `mb-0 text-[2.5rem] text-shadow-[0_0_1.5rem_#111111]`,
                                    `leading-[1.25] text-white mb-[0.8125rem] clear-both wrap-break-word 
                                    font-black [text-decoration:none]`
                                )}
                            >
                                The Most Career Focused UK Degree in Nepal.
                            </h1>

                            <div className="flex md:flex-row flex-col justify-start gap-6 md:gap-12 my-4">
                                <Link
                                    href={"https://apply.patancollege.edu.np/"}
                                    target="_blank"
                                    className={`w-fit text-xs font-bold leading-[1.125rem] tracking-[0.0625rem] text-white
                                             [text-decoration:none] uppercase
                    border border-white border-2  p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
                    after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                    after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:border-secondary-red hover:transition-[all_0.15s_ease]
                    after:hover:text-primary-red after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                      hover:after:transition-[all_0.15s_ease]
                            hover:after:transform hover:after:translate-x-[0.625rem]
                            
                  `}
                                >
                                    Enroll now
                                </Link>
                                <Link
                                    href={"#courses"}
                                    // target="_blank"
                                    /*  className={`futura-medium text-[0.6875rem] leading-[1.125rem] tracking-[0.0625rem] text-white
                                         [text-decoration:none] uppercase
                border border-white p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
                after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:text-[#A31F34] hover:border-[#A31F34] hover:transition-[all_0.15s_ease]
                after:hover:text-[#A31F34] after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                  hover:after:text-[#A31F34] hover:after:transition-[all_0.15s_ease]
                        hover:after:transform hover:after:translate-x-[0.625rem]
                        
              `} */
                                    className={`w-fit text-xs font-bold leading-[1.125rem] tracking-[0.0625rem] text-white
                                             [text-decoration:none] uppercase
                    border border-white border-2  p-[0.875rem_1.25rem] inline-block relative overflow-visible transition-[all_0.35s_ease-out]
                    after:content-[url(/svgs/longarrowright-red.svg)] after:text-[1.0625rem] after:pl-[0.3125rem] after:block after:float-right 
                    after:transition-[all_0.35s_ease-out] after:translate-y-[-0.125rem] hover:border-secondary-red hover:transition-[all_0.15s_ease]
                    after:hover:text-primary-red after:hover:translate-x-[0.625rem] after:hover:transition-[all_0.15s_ease]
                      hover:after:transition-[all_0.15s_ease]
                            hover:after:transform hover:after:translate-x-[0.625rem]
                            
                  `}
                                >
                                    Explore Our Courses
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="header-gradient bg-transparent" />
            {/*  <figure
                className="absolute top-0 left-0 m-0 z-0 h-full w-full"
                style={{
                    backgroundImage: `url('/pcps_bg.jpeg')`,
                    // backgroundImage: `url('/pcpsbg.jpg')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    // backgroundColor: "rgba(0, 0, 0, 0.3)",
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                    backgroundBlendMode: "multiply",
                    margin: 0,
                    zIndex: 0,
                }}
            /> */}
            <div className="absolute top-0 left-0 m-0 z-0 h-full w-full pointer-events-none">
                <Image
                    src={BgImage}
                    alt="Pcps"
                    fill
                    className="h-full w-full object-cover object-center"
                    style={{ zIndex: 0 }}
                    priority
                />
                <div className="absolute inset-0 bg-[rgba(0,0,0,0.2)] mix-blend-multiply pointer-events-none" />
            </div>

            {/*  <p
                className="text-white text-[18rem] font-black absolute uppercase right-0 pointer-events-none z-[1] select-none"
                ref={pcpsTitleRef}
                style={{
                    transform: `translate3d(0px, -${window.scrollY * 0.175}px, 0px)`,
                    // width: "53.625rem",
                    // height: "22.25rem",
                    bottom: "-12.5rem",
                    // bottom: "0",
                }}
            >
                PCPS
            </p> */}
            <p
                className="
                    text-white font-black tracking-tight absolute uppercase right-0 pointer-events-none z-[1] select-none
                    text-[7rem] sm:text-[10rem] md:text-[14rem] lg:text-[18rem]
                "
                ref={pcpsTitleRef}
                style={{
                    transform: `translate3d(0px, -${window.scrollY * 0.175}px, 0px)`,
                    bottom: window.innerWidth >= 1024
                        ? "-12.5rem"
                        : window.innerWidth >= 768
                            ? "-8rem"
                            : window.innerWidth >= 640
                                ? "-4rem"
                                : "-2rem"
                }}
            >
                PCPS
            </p>
        </header>
    }

}
